import { render, staticRenderFns } from "./border-rect-item.vue?vue&type=template&id=0927bee7&"
import script from "./border-rect-item.vue?vue&type=script&lang=js&"
export * from "./border-rect-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports